import { ReactElement } from 'react';
import { ProductData } from '@client/product/components/ProductData/ProductData';
import { SimilarProducts } from '@client/product/components/ProductData/SimilarProducts';
import { ProductDetails } from '@client/product/components/ProductDetails/ProductDetails';
import { ProductGallery } from '@client/product/components/ProductGallery';
import { ProductFullType } from '@client/product/redux/products/full/types';
import { PrimaryLayout } from '@lib/components/PrimaryLayout';
import { Column } from '@lib/components/PrimaryLayout/Column';
import './style.scss';

interface Props {
  product: ProductFullType;
  onAddToCart: (sku: string) => void;
}

export const Content = ({
  product,
  onAddToCart,
}: Props): ReactElement => {
  const { description, packaging, manufacturer, sku } = product;
  const { title } = description;
  const { name, logo } = manufacturer;

  return (
    <>
        <PrimaryLayout>
          <Column
            left={(
              <div className='ProductGallery-Wrapper'>
                <ProductGallery
                  manufacturerLogo={logo}
                  manufacturerName={name}
                  sku={sku}
                  productName={title}
                />
              </div>
            )}
            right={(
              <div className='ProductData-Wrapper'>
                <ProductData
                  product={product}
                  onAddToCart={onAddToCart}
                />
              </div>
            )}
            className="ProductPage-MainSection"
          />
        </PrimaryLayout>

      <section className='ProductDetailsWrapper'>
        <PrimaryLayout>
          <ProductDetails
            sku={sku}
            packaging={packaging}
            description={product.description}
            isInkFinderLinkDisplayed={false}
          />
        </PrimaryLayout>
      </section>

      <section className="ProductDetailsWrapper">
        <PrimaryLayout>
          <SimilarProducts />
        </PrimaryLayout>
      </section>
    </>
  );
};
